import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SyncService {
  private slideIndexSubject = new BehaviorSubject<number>(0);
  private forceSlideIndexSubject = new Subject<number>();
  getSlideIndex(): Observable<number> {
    return this.slideIndexSubject.asObservable();
  }
  getForceSlideIndex(): Observable<number> {
    return this.forceSlideIndexSubject.asObservable();
  }
  setSlideIndex(index: number): void {
    this.slideIndexSubject.next(index);
  }
  setSlideIndexForce(index: number): void {
    this.slideIndexSubject.next(index);
    this.forceSlideIndexSubject.next(index);
  }

  getCurrentSlideIndex(): number {
    return this.slideIndexSubject.getValue();
  }
}
